import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import { Select } from "antd";

function SelectItems({ label, name, placeholder, options, ...rest }) {
  return (
    <div className="mb-3">
      <div className="mb-1">
        <label htmlFor={name}>{label}</label>
      </div>
      <Field name={name}>
        {({ field, form }) => (
          <Select
            id={name}
            placeholder={placeholder}
            value={field.value || undefined}
            options={options}
            style={{ width: "100%" }}
            status={form.errors[name] && form.touched[name] ? "error" : ""}
            onChange={(value) => form.setFieldValue(name, value)}
            onBlur={() => form.setFieldTouched(name, true)}
            {...rest}
          />
        )}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default SelectItems;
